module.exports = __webpack_public_path__ + "img/jack-lantern-mask.2e4f6f56.png";